const state = () => ({
  attackingWidth: {
    attackingWidth: 0
  },

  approachPlay: {
    passIntoSpace: false,
    overlapLeft: 0,
    overlapRight: 0,
    playOutOfDefence: false
  },

  passing: 0,
  tempo: 0,
  timeWasting: 0,
  
  finalThird: {
    workBallIntoBox: false,
    shootOnSight: false,
    hitEarlyCrosses: false,
    playForSetPieces: false
  },

  dribbling: 0,
  creativeFreedom: 0
});

const mutations = {
  updateAttackingWidth (state, value) {
    state.attackingWidth.attackingWidth = value;
  },

  updatePassIntoSpace (state, value) {
    state.approachPlay.passIntoSpace = value;
  },
  updateOverlapLeft (state, value) {
    state.approachPlay.overlapLeft = value;
  },
  updateOverlapRight (state, value) {
    state.approachPlay.overlapRight = value;
  },
  updatePlayOutOfDefence (state, value) {
    state.approachPlay.playOutOfDefence = value;
  },
  updatePassing (state, value) {
    state.passing = value;
  },
  updateTempo (state, value) {
    state.tempo = value;
  },
  updateTimeWasting (state, value) {
    state.timeWasting = value;
  },

  updateWorkBallIntoBox (state, value) {
    state.finalThird.workBallIntoBox = value;
  },
  updateShootOnSight (state, value) {
    state.finalThird.shootOnSight = value;
  },
  updateHitEarlyCrosses (state, value) {
    state.finalThird.hitEarlyCrosses = value;
  },
  updatePlayForSetPieces (state, value) {
    state.finalThird.playForSetPieces = value;
  },
  updateDribbling (state, value) {
    state.dribbling = value;
  },
  updateCreativeFreedom (state, value) {
    state.creativeFreedom = value;
  }
};

export default {
  state,
  mutations
};
